import { useEffect } from 'react';

import { useInView } from 'react-intersection-observer';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { JPDOverlayTemplate } from '@/components/signup/layouts/product-overlay-template.tsx';
import { UfoCustomTimingWrapper } from '@/components/signup/utils/ufo-custom-timing-wrapper';
import { ufoEventRedirectToProduct } from '@/components/signup/utils/ufo-events';
import { UfoCustomTimingKey } from '@/components/signup/utils/ufo.types';
import { useProvisioningLatencyUfo } from '@/templates/ondemand/signup/confirmation/confirmation-page/src/hooks/use-provisioning-latency-ufo';

import { useCloudStatus } from '../../hooks/use-cloud-status';
import { useCloudStatusRedirection } from '../../hooks/use-cloud-status-redirection';

import { LoadingAnimationContainer } from './loading-animation-container';

export const JiraProductDiscoveryProvisioningUi = () => {
	const { ref } = useInView();
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { triggerOnSuccess, startPerceivedProvisioningTimer } = useCloudStatus();
	const { redirectUrl } = useCloudStatusRedirection();
	const { completeAll } = useProvisioningLatencyUfo();

	useEffect(() => {
		startPerceivedProvisioningTimer();
	}, [startPerceivedProvisioningTimer]);

	useEffect(() => {
		if (redirectUrl) {
			ufoEventRedirectToProduct.success({
				customData: {
					reactComponent: 'JPD default',
					analyticsEvent: 'redirected',
					redirectFrom: 'confirmationPage',
					provisioningStatus: 'success',
				},
			});
			completeAll('provisioning-screen');
			window.location.assign(redirectUrl);
		}
	}, [completeAll, createAnalyticsEvent, triggerOnSuccess, redirectUrl]);

	return (
		<div ref={ref} data-testid="jpd-provisioning-ui">
			<UfoCustomTimingWrapper
				ufoEvent={ufoEventRedirectToProduct}
				ufoCustomTimingKey={UfoCustomTimingKey.JIRA_PRODUCT_DISCOVERY_ONBOARDING_SPINNER_DWELL_TIME}
			>
				<JPDOverlayTemplate size="sm">
					<LoadingAnimationContainer />
				</JPDOverlayTemplate>
			</UfoCustomTimingWrapper>
		</div>
	);
};
